<template>
  <OnexAlert :type="getType" dismissible :class="isAndroid ? 'addAndroidPadding' : ''">
    <slot name="message"></slot>
    <template v-if="!hasSlot('message')">
      <div v-if="type === 'error' && expandable && (details?.detail || '')">
        <v-icon
          v-if="selected !== index"
          @click="selected = index"
          :icon="mdiArrowDownDropCircleOutline"
        />
        <v-icon v-else @click="selected = -1" :icon="mdiArrowUpDropCircleOutline" />
        <span class="header">{{ message }}</span>
        <div v-if="selected === index" class="details">
          CorrelationId: {{ $t(details?.correlationId || '') }} <br />
          TraceId: {{ $t(details?.traceId || '') }} <br />
          Details: {{ $t(details?.detail || '') }}
        </div>
      </div>
      <span v-else>
        {{ message }}
      </span>
    </template>
  </OnexAlert>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useGlobalStore } from '@/stores/global/global.store';
import type { ComponentOptions, PropType } from 'vue';
import { mapStores } from 'pinia';
import { mdiArrowDownDropCircleOutline, mdiArrowUpDropCircleOutline, mdiClose } from '@mdi/js';
import { Notifications, OnexAlert } from '@primerica/onex-ui-lib';
import type { IAlertDetails } from '@/stores/global/globalStore.model.ts';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';

export type AlertType = 'error' | 'success' | 'warning' | 'info' | undefined;

const componentOptions: ComponentOptions = {
  name: 'AlertComponent',
  components: {
    OnexAlert,
  },
  props: {
    type: {
      type: String as PropType<AlertType>,
      required: true,
    },
    details: {
      type: Object as PropType<IAlertDetails>,
      required: false,
      default: () => {},
    },
    displayIcon: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: 0,
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
    expandable: {
      type: Boolean,
      default: true,
    },
    coloredBorder: {
      type: Boolean,
      default: true,
    },
    autoDismiss: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    isAndroid: false,
    selected: -1,
    mdiClose,
    mdiArrowDownDropCircleOutline,
    mdiArrowUpDropCircleOutline,
    Notifications,
  }),
  computed: {
    ...mapStores(useGlobalStore),
    message() {
      if (this.details.key) {
        return this.$t(this.details.key);
      }
      return this.details.message;
    },
    getType() {
      switch (this.type) {
        case 'error':
          return Notifications.error;
        case 'success':
          return Notifications.success;
        case 'warning':
          return Notifications.warning;
        default:
          return Notifications.info;
      }
    },
  },
  methods: {
    hasSlot(name = 'message') {
      return !!this.$slots[name];
    },
  },
  mounted() {
    this.isAndroid = CapacitorFacade.isAndroid();
    if (this.type !== 'error' && this.autoDismiss) {
      window.setTimeout(() => {
        this.globalStore.removeAlert(this.index);
      }, 5000);
    }
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.addAndroidPadding {
  margin-top: 35px !important;
}
</style>
